<template>
    <paper class="carrierManage">
        <el-tabs v-model="activeName">
            <el-tab-pane label="日运力承诺" name="Everyday">
                <Everyday />
            </el-tab-pane>
            <el-tab-pane label="承运商资源反馈" name="ResourcesFeedback">
                <ResourcesFeedback />
            </el-tab-pane>
            <el-tab-pane label="基地承运商发运及监控" name="Monitoring">
                <Monitoring />
            </el-tab-pane>
        </el-tabs>
    </paper>
</template>
<script>
import paper from '@/components/core/paper/Paper';
import Everyday from './everyday/Index';
import ResourcesFeedback from './resourcesFeedback/Index';
import Monitoring from './monitoring/Index';
export default {
    name: 'carrierManage',
    components: { paper, Everyday, ResourcesFeedback, Monitoring },
    data() {
        return {
            activeName: 'Everyday'
        };
    }
};
</script>
<style lang="less">
.carrierManage{
    .tablePage{
        .el-table {
            min-height: calc(~ '100vh - 223px') !important;
            max-height: calc(~ '100vh - 223px') !important;
        }
    }
}
</style>